/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCatalog200ResponseCategoriesInnerProductsInnerType } from './GetCatalog200ResponseCategoriesInnerProductsInnerType';
import {
    GetCatalog200ResponseCategoriesInnerProductsInnerTypeFromJSON,
    GetCatalog200ResponseCategoriesInnerProductsInnerTypeFromJSONTyped,
    GetCatalog200ResponseCategoriesInnerProductsInnerTypeToJSON,
    GetCatalog200ResponseCategoriesInnerProductsInnerTypeToJSONTyped,
} from './GetCatalog200ResponseCategoriesInnerProductsInnerType';

/**
 * 
 * @export
 * @interface AddCatalogProductsRequestInner
 */
export interface AddCatalogProductsRequestInner {
    /**
     * 
     * @type {string}
     * @memberof AddCatalogProductsRequestInner
     */
    id: string;
    /**
     * 
     * @type {GetCatalog200ResponseCategoriesInnerProductsInnerType}
     * @memberof AddCatalogProductsRequestInner
     */
    type: GetCatalog200ResponseCategoriesInnerProductsInnerType;
    /**
     * 
     * @type {string}
     * @memberof AddCatalogProductsRequestInner
     */
    organizationItemId: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddCatalogProductsRequestInner
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the AddCatalogProductsRequestInner interface.
 */
export function instanceOfAddCatalogProductsRequestInner(value: object): value is AddCatalogProductsRequestInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('organizationItemId' in value) || value['organizationItemId'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function AddCatalogProductsRequestInnerFromJSON(json: any): AddCatalogProductsRequestInner {
    return AddCatalogProductsRequestInnerFromJSONTyped(json, false);
}

export function AddCatalogProductsRequestInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddCatalogProductsRequestInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': GetCatalog200ResponseCategoriesInnerProductsInnerTypeFromJSON(json['type']),
        'organizationItemId': json['organizationItemId'],
        'enabled': json['enabled'],
    };
}

export function AddCatalogProductsRequestInnerToJSON(json: any): AddCatalogProductsRequestInner {
    return AddCatalogProductsRequestInnerToJSONTyped(json, false);
}

export function AddCatalogProductsRequestInnerToJSONTyped(value?: AddCatalogProductsRequestInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': GetCatalog200ResponseCategoriesInnerProductsInnerTypeToJSON(value['type']),
        'organizationItemId': value['organizationItemId'],
        'enabled': value['enabled'],
    };
}

